import { render, staticRenderFns } from "./appointmentSetting.vue?vue&type=template&id=50694d0e&scoped=true&"
import script from "./appointmentSetting.vue?vue&type=script&lang=js&"
export * from "./appointmentSetting.vue?vue&type=script&lang=js&"
import style0 from "./appointmentSetting.vue?vue&type=style&index=0&id=50694d0e&lang=scss&scoped=true&"
import style1 from "./appointmentSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50694d0e",
  null
  
)

export default component.exports